import type { CreateRequestTaskCommand } from '../../models/request/createRequestTaskCommand';
import { requests } from '../httpClient';

export const Requests = {
    submitRequestAsync: (requestCommand: CreateRequestTaskCommand) => requests.post(`Request`, requestCommand)
};
